import { SITE } from "../lib/site";

export default function About() {
  return (
    <div data-testid="about-page" className="bg-[#0B0F0E]">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-16">
        <div className="overline"><span className="h-line" />About Upsurge</div>
        <h1 className="font-display text-[#F4EFE6] text-6xl md:text-7xl lg:text-[5.5rem] mt-7 leading-[0.95] max-w-4xl">
          A land company built on <span className="italic-gold">trust, patience &amp; planning craft.</span>
        </h1>
        <p className="text-[#9BA39B] text-lg max-w-3xl mt-9 leading-relaxed">
          Upsurge Strategic Land Ltd is a London-headquartered land promotion and planning consultancy working with farmers, estates, councils and private landowners across the United Kingdom — across both residential and commercial markets.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-28 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7">
          <img src={SITE.images.meeting} alt="Professional meeting" className="w-full h-[560px] object-cover" />
        </div>
        <div className="lg:col-span-5 lg:pl-6">
          <div className="overline">Our mission</div>
          <h2 className="font-display text-[#F4EFE6] text-4xl mt-4 leading-tight">
            Aligning landowner ambition with <span className="italic-gold">planning reality.</span>
          </h2>
          <p className="text-[#9BA39B] mt-6 leading-relaxed">
            We invest our own resources to navigate the planning process — surveys, technical work, remediation strategy, community engagement, Local Plan promotion and consent. Our success only follows yours: we share in the uplift only after consent is achieved.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-6">
            <div>
              <div className="font-display text-5xl text-[#C9A24B]">2025</div>
              <div className="text-xs tracking-[0.22em] uppercase text-[#9BA39B] mt-2 font-semibold">Year founded</div>
            </div>
            <div>
              <div className="font-display text-5xl text-[#C9A24B]">UK</div>
              <div className="text-xs tracking-[0.22em] uppercase text-[#9BA39B] mt-2 font-semibold">Nationwide focus</div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#11171A] border-y border-[#F4EFE6]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-28 grid md:grid-cols-3 gap-10">
          {[
            { t: "Patient capital", d: "We commit for the long term. Most strategic sites take years — we are built to walk that path with you." },
            { t: "Planning craft", d: "Our team blends planning consultancy, local political insight, viability expertise and remediation knowledge on every instruction." },
            { t: "Discreet partnership", d: "Strict confidentiality. Sensitive land discussions handled with the care a family business expects." },
          ].map((v, i) => (
            <div key={v.t} data-testid={`value-${i}`}>
              <div className="overline">0{i+1}</div>
              <div className="font-display text-3xl text-[#F4EFE6] mt-4">{v.t}</div>
              <p className="text-[#9BA39B] mt-4 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
